module.exports = __webpack_public_path__ + "static/fundraising-e619cb99318be363da0f6539a2da1406.png";